module.exports = __webpack_public_path__ + "img/e.3e398259.png";